import { APP } from '@/constants/app.constant';
import { CustomResponse } from '@/models/custom-response.model';
import { CustomUser } from '@/models/custom-user.model';
import axios from 'axios';

export const AuthenticationService = {
    login,
    logout,
    changePassword,
    forgotPassword,
    resetPassword,
    resendConfirmation,
};

function login(email: string, password: string): Promise<CustomUser> {

    return axios.post(`${APP.API_URL}/auth/login`, { email, password })
        .then(handleResponse)
        .then((response: CustomResponse<CustomUser>) => {

            const user: CustomUser = new CustomUser(response.data);
            localStorage.setItem('user', JSON.stringify(user));

            if (user.token) {
                axios.defaults.headers.common.Authorization = user.token;
            }

            return user;
        }).catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function changePassword(
    old_password: string, // tslint:disable-line: variable-name
    new_password: string, // tslint:disable-line: variable-name
    new_password_confirmation: string, // tslint:disable-line: variable-name
): Promise<CustomResponse<any>> {

    return axios.patch(`${APP.API_URL}/auth/change-password`, { old_password, new_password, new_password_confirmation })
        .then(handleResponse)
        .then((response: CustomResponse<any>) => {
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function resetPassword(password: string, passwordConfirmation: string, token: string): Promise<CustomResponse<any>> {
    return axios.post(`${APP.API_URL}/auth/reset-password`, {
        token,
        password,
        password_confirmation: passwordConfirmation,
    })
        .then(handleResponse)
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function forgotPassword(email: string): Promise<CustomResponse<any>> {
    return axios.post(`${APP.API_URL}/auth/forgot-password`, {
        email,
    })
        .then(handleResponse)
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function resendConfirmation(email: string): Promise<CustomResponse<any>> {
    return axios.post(`${APP.API_URL}/auth/resend-confirmation`, {
        email,
    })
        .then(handleResponse)
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function logout() {
    localStorage.removeItem('user');
    delete axios.defaults.headers.common.Authorization;
}

function handleResponse(response: any) {
    return response.data;
}
